<template>
    <div v-if="user" class="user-info-basic flex-row items-center p-relative">
        <div v-if="user.name && user.$$chatId" class="flex-row items-center flex-wrap">
            <div class="first" v-html="$nameOrNick(user)" />
            <div v-if="user.$$chatId" class="second" v-html="`(${user.profile.nickname})`" />
        </div>
        <div v-else-if="!user.name && user.$$chatId" class="flex-row items-center flex-wrap">
            <div class="first" v-html="$nameOrNick(user)" />
        </div>
        <div v-if="!user.$$chatId" class="flex-row items-center flex-wrap">
            <div class="first" v-html="user.profile.nickname" />
        </div>
        <div class="badges-container flex-row flex-between">
            <div class="badges flex-row flex-wrap items-center">
                <div
                    v-if="$options.filters.isNewbie(user)"
                    class="badge badge-brd red m-r-4"
                    v-html="$translate('NEWBIE')"
                />
                <BadgeFriendType class="flex-wrap m-r-4" :user="user" :chat="userChat" />
                <LastSeen class="flex-wrap" :timestamp="user.last_sign_in_at" />
                <NoOnsCampaignBadge v-if="!user.$$chatId" :user="user" />
                <div class="friend-functions flex-row items-center flex-wrap" v-if="chat && user.$$chatId">
                    <div class="divider m-l-8 m-r-8">|</div>
                    <div v-if="!hideBookmark" class="bookmark m-r-4" @click="onClickBookmark">
                        <img :src="bookmarkIcon" />
                    </div>
                    <FriendMemo v-if="!hideMemo" class="flex-wrap m-r-8" :chat="chat" />
                    <AcceptedHistory
                        v-if="user.$$premium && myPremium()"
                        class="flex-wrap m-r-8"
                        :chat="chat"
                        :user="user"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FriendMemo from '@/components/common/FriendMemo'
import AcceptedHistory from '@/components/common/AcceptedHistory'
import NoOnsCampaignBadge from '@/components/common/NoOnsCampaignBadge'

export default {
    name: 'UserInfoBasic',
    components: { FriendMemo, AcceptedHistory, NoOnsCampaignBadge },
    props: {
        user: {
            type: Object,
            required: true,
        },
        hideBookmark: {
            type: Boolean,
            default: true,
        },
        hideMemo: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        age() {
            if (!this.user.profile) return

            const birthday = this.user.profile.birthday
            if (!birthday) return

            return this.$options.filters.asAge(birthday)
        },
        height() {
            if (!this.user.profile) return

            return this.user.profile.height
        },
        userChat() {
            return (this.$store.getters.chatList || []).find(c => c.user_id === this.user.id)
        },
        chat() {
            return this.$store.getters.chat
        },
        bookmarkIcon() {
            return require(`@/assets/images/chatroom/chat_bookmark_${this.chat.bookmark ? 'active' : 'inactive'}.svg`)
        },
    },
    methods: {
        async onClickBookmark() {
            const bookmark = !this.chat.bookmark

            try {
                this.$loading(true)
                await this.$store.dispatch('bookmarkChat', { chat: this.chat, bookmark })
                this.$toast.success(`북마크${bookmark ? ' ' : '가 해제'}되었습니다`)
            } catch (e) {
                this.$toast.error(e.data)
            } finally {
                this.$loading(false)
            }
        },
        myPremium() {
            if (this.user.$$premium) {
                const premium = this.$options.filters.hasProduct(this.user, 'premium')
                return this.$store.getters.agent.id === premium.agent_id
            }
            return false
        },
    },
}
</script>

<style lang="scss" scoped>
.user-info-basic {
    .first {
        font-size: 14px;
        margin-right: 4px;
        color: $black;
        @include f-medium;
    }

    .second {
        font-size: 12px;
        color: $grey-07;
    }

    .badges {
        margin-left: 8px;

        .snackbar {
            top: 32px;
        }
    }

    .divider {
        color: $grey-04;
    }

    .friend-functions {
        .bookmark {
            display: -webkit-box !important;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background-color: $grey-01;

            @include center;
        }
    }
}
::v-deep .no-ons-campaign {
    &.third-panel {
        margin-top: 0;
        margin-left: 4px;
    }
}
</style>
